import { createIcon } from '@integration-frontends/common/ui/icons/create-icon';
import React from 'react';
import './icon-drag-and-drop.scss'

export const IconDragAndDrop = createIcon(<div className="icon-drag-and-drop" />);
